import { useMemo, useCallback } from 'react';
import { useQuery, useMutation } from '@apollo/client';
import { get as dig } from 'lodash';

import GQL_ASSET_DESCRIPTION_QUERY from './gql/AssetDescriptionQuery.graphql';
import GQL_DESCRIBABLE_UPDATE from './gql/MutationDescribableUpdate.graphql';

const useAssetDescription = ({ nodeId }) => {
  const { data, loading: queryLoading, error: queryError } = useQuery(
    GQL_ASSET_DESCRIPTION_QUERY,
    {
      variables: { id: nodeId },
      skip: !nodeId,
      fetchPolicy: 'cache-and-network',
    },
  );
  const description = useMemo(
    () => dig(data, 'node.description.content', '') || '',
    [data],
  );

  const [
    mutationUpdateContent,
    { loading: mutationLoading, error: mutationError },
  ] = useMutation(GQL_DESCRIBABLE_UPDATE);
  const setDescription = useCallback(
    ({ assetNodeId = nodeId, content }) =>
      mutationUpdateContent({
        variables: {
          input: {
            id: assetNodeId,
            content,
          },
        },
      }),
    [mutationUpdateContent, nodeId],
  );

  const isLoading = queryLoading || queryError;
  const isMutating = mutationLoading || mutationError;

  return {
    isLoading,
    isMutating,
    description,
    setDescription,
  };
};

export default useAssetDescription;
